import { GameConstants } from "./GameConstants";
import { RoadState } from "./states/road/RoadState";
import { Boot } from "./states/Boot";
import { PreLoader } from "./states/Preloader";
import { SplashState } from "./states/splash/SplashState";
import { StatsState } from "./states/stats/StatsState";
import { InstructionsState } from "./states/instructions/InstructionsState";

export class Game extends Phaser.Game {

    public static currentInstance: Phaser.Game;

    constructor() {

        let renderer: number;
        let ua = navigator.userAgent;

        if (ua.match(/iPhone/i) || ua.match(/iPad/i) || ua.match(/iPod/i) || /Kindle/i.test(ua) || /Silk/i.test(ua) || /KFTT/i.test(ua) || /KFOT/i.test(ua) || /KFJWA/i.test(ua) || /KFJWI/i.test(ua) || /KFSOWI/i.test(ua) || /KFTHWA/i.test(ua) || /KFTHWI/i.test(ua) || /KFAPWA/i.test(ua) || /KFAPWI/i.test(ua)) {
            renderer = Phaser.CANVAS;
        } else {
            renderer = Phaser.AUTO;
        }
        
        super(GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT, renderer, "content", null, false, true);

        Game.currentInstance = this;
        
        this.state.add("PreLoader", PreLoader, false); 
        this.state.add("SplashState", SplashState, false);
        this.state.add("StatsState", StatsState, false);
        this.state.add("InstructionsState", InstructionsState, false);
        this.state.add("RoadState", RoadState, false);

        this.state.add("Boot", Boot, true);
    }
}
    